import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class ScheduleControlErrorsService {
  private readonly errors = new BehaviorSubject<{ scheduleId: number; fields: { [key: string]: string[] } } | null>(
    null
  );
  errors$ = this.errors.asObservable();

  constructor() {}

  clearErrors() {
    this.errors.next(null);
  }

  setErrors(errors: { scheduleId: number; fields: { [key: string]: string[] } }) {
    this.errors.next(errors);
  }

  getErrors() {
    return this.errors.asObservable();
  }
}
